.resultsButton {
  flex-shrink: 0;
}

.height100Percent {
  height: 100%;
}

.votingSquareButton {
  display: flex;
  width: 34px;
  height: 34px;
  padding: 0;

  i {
    margin: auto;
  }
}

.votingSquareButtonLarge {
  width: 44px;
  height: 44px;
}

:global(.side-panel__list).votingForm {
  margin: 0;
  gap: var(--spacer-3);

  > li:not(:last-child) {
    padding-bottom: var(--spacer-3);
  }
}

.votingDetailStatus {
  flex-basis: 0;
  flex-grow: 1;
  border-right: 1px solid var(--theme-light-border);

  &:last-child {
    border-right-color: transparent;
  }
}

.votingRoundPill {
  height: 35px;
  display: flex;
  align-items: center;
  border-radius: 48px;
  padding: 0 var(--spacer-5);
  width: fit-content;
  margin: auto;
}

.votingRoundPillGray {
  background-color: var(--theme-secondary-background);
  color: var(--theme-secondary-text);
}

.votingRoundPillGreen {
  background-color: var(--theme-green-background);
  color: var(--theme-green-text);
}

.votingAddTimeButtons > aha-button {
  flex-basis: 0;
  flex-grow: 1;
}

.votingEndConfirmation {
  border-radius: 4px;
  border: 1px solid var(--theme-primary-border);
  background-color: var(--theme-secondary-background);
}

.votingResult {
  min-height: 60px;
}

.votingResultDisabled {
  .votingResultName {
    color: var(--theme-tertiary-text);
  }
}

.votingResult:not(.votingResultDisabled):hover {
  .votingResultDate {
    display: inline;
  }

  .votingResultDeleteButton {
    display: block;
  }
}

.votingResultDate,
.votingResultDeleteButton {
  display: none;
}

.votingResultActions {
  flex-shrink: 0;
}

.votingConfirmActions {
  display: flex;
  gap: var(--spacer-2);
}

.votingGrowButton,
.votingGrowAction {
  flex-grow: 1;
}

.votingResultAction,
.menuTrigger {
  cursor: pointer;
}

.votingResultName {
  margin-right: var(--spacer-2);
  display: flex;
  align-items: center;
}

.votingResultName > :first-child {
  padding-right: var(--spacer-2);
  height: 16px;
}

.menuTrigger {
  color: var(--theme-secondary-text);
  display: flex;

  aha-icon {
    color: var(--theme-tertiary-text);
  }
}

.voteCountVoter {
  color: var(--theme-secondary-text);
}

:global(.side-panel__hover-background):hover .voteCountVoter {
  color: var(--theme-primary-text);
}

.voteCountSeparator {
  flex-grow: 1;
  border-bottom: 1px solid var(--theme-light-border);
}

.votingResultIcon {
  color: var(--theme-tertiary-text);
  flex-shrink: 0;
  width: 16px;

  svg {
    width: 16px;
    height: 16px;
  }
}

.votingResultsHeader {
  border-bottom: 1px solid var(--theme-light-border);
  align-items: baseline;

  :global(.flex-row) {
    align-items: baseline;
  }
}

.votingResultTitle {
  align-items: flex-end;
}

.votingResultSummaryText {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: var(--theme-secondary-text);
  padding-left: calc(16px + var(--spacer-2));
}

.flexGrow {
  flex-grow: 1;
}

.optionToggle {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--spacer-3);
  padding: var(--spacer-3);
  border: 1px solid var(--theme-primary-border);
  border-radius: var(--Common--border-radius);
}

.optionToggleInput {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: var(--spacer-3);

  & + & {
    border-top: 1px solid var(--theme-light-border);
    padding-top: var(--spacer-3);
  }
}

.inlineEditable {
  display: flex;
}

.inlineEditable input,
.inlineEditable input:focus {
  font: inherit;
  color: inherit;
  background: inherit;
  border: inherit;
  overflow: visible;
  margin: 0;
  padding: 0;
  box-shadow: none;
  height: auto;
  width: 100%;
}

.inlineEditableEditButton {
  visibility: hidden;
}

.inlineEditable:not(.inlineEditableEditing):hover .inlineEditableEditButton {
  visibility: visible;
}

.votingDetails {
  flex-direction: column;
  display: flex;
  height: 100%;
}

.pokerCardList {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--spacer-4);
}

.pokerCardOuter,
.pokerCardInner {
  --corner-size: 14px;
  --border-radius: 3px;
  --border-width: 1.5px;
  border-radius: calc(var(--border-radius) * 1.6);
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  box-sizing: border-box;
  font-weight: var(--font-weight-h-700);
}

.pokerCardOuter {
  --outer-border-color: var(--theme-accent-text);
  --inner-border-color: var(--theme-accent-icon);
  --outer-fill: var(--theme-primary-background);
  --inner-fill: var(--theme-container-light-background);
  padding: calc(var(--corner-size) / 2.4);
  border: var(--border-width) solid var(--outer-border-color);
  background-color: var(--outer-fill);
  transition: all 0.12s ease-out;
  box-sizing: border-box;
  max-width: 100%;
}

.pokerCardInner {
  position: relative;
  background-color: var(--inner-fill);
  border: var(--border-width) solid var(--inner-border-color);
  border-radius: calc(var(--border-radius) * 1.2);
  max-width: 100%;
  color: var(--theme-tertiary-text);
}

.pokerCardIsSelected {
  cursor: pointer;
  --outer-border-color: var(--theme-focus-shadow);
  --outer-fill: var(--theme-button-ghost-hovered);
  --inner-border-color: var(--theme-blue-border);
  --inner-fill: color-mix(
    in srgb,
    var(--theme-button-ghost-hovered),
    var(--theme-primary-background) 50%
  );
  .pokerCardContent,
  .pokerCardInner {
    background-color: var(--aha-blue-50);
    color: var(--aha-blue-500);
  }
  .pokerCardDot {
    color: var(--aha-blue-400);
  }
}

/* Hover Effect for Selectable Cards */
.pokerCardIsButton:not(.pokerCardIsSelected):hover {
  --outer-border-color: var(--theme-focus-shadow);
  --inner-border-color: var(--theme-secondary-border);
  --inner-fill: var();
  --inner-fill: var(--theme-container-light-background);
  --outer-fill: var();
  --outer-fill: var(--theme-primary-background);
  transform: scale(1.05);
  cursor: pointer;
}

.pokerCardIsSubmitted {
  --outer-border-color: var(--aha-jade-600);
  --outer-fill: var(--aha-jade-10);
  --inner-border-color: var(--aha-green-500);
  --inner-fill: var(--aha-green-100);
  color: var(--aha-jade-800);
  .pokerCardContent {
    color: var(--theme-alert-success-text);
  }
  .pokerCardInner {
    color: var(--aha-green-600);
  }
}

.pokerCardDot {
  background: var(--outer-fill);
  border-radius: var(--border-radius);
  z-index: 20;
  font-size: 70%;
  position: relative;
}

.pokerCardDot:before {
  border: var(--border-width) solid var(--inner-border-color);
}

.pokerCardDot:before,
.pokerCardDot:after {
  content: '';
  background: var(--outer-fill);
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.pokerCardDot:before {
  border: var(--border-width) solid var(--inner-border-color);
  width: 70%;
  height: 60%;
}

.pokerCardDotBottomRight:before,
.pokerCardDotBottomRight:after {
  border-radius: var(--border-radius) 0 0 0;
}

.pokerCardDotBottomRight:before {
  left: calc(-1 * var(--border-width));
  top: calc(-1 * var(--border-width));
}

.pokerCardDotBottomRight:after {
  top: 0;
  left: 0;
}

.pokerCardDotTopLeft:before,
.pokerCardDotTopLeft:after {
  border-radius: 0 0 var(--border-radius) 0;
}

.pokerCardDotTopLeft:before {
  right: calc(-1 * var(--border-width));
  bottom: calc(-1 * var(--border-width));
}

.pokerCardDotTopLeft:after {
  right: 0;
  bottom: 0;
}

.pokerCardDotTopLeft {
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-30%, -40%);
  padding: 0 4px 2px 0;
}

.pokerCardDotBottomRight {
  position: absolute;
  bottom: 0;
  right: 0;
  transform: translate(30%, 40%);
  padding: 2px 0 0 4px;
}

.pokerCardContent {
  padding: calc(var(--corner-size) / 1.2) calc(var(--corner-size) / 2.1);
  white-space: nowrap;
  background-color: var(--inner-fill);
  border-radius: var(--border-radius);
  font-size: var(--font-size-h-700);
  font-weight: var(--font-weight-h-500);
  color: var(--theme-secondary-text);
  max-width: calc(100% - var(--spacer-2));
  text-overflow: ellipsis;
  overflow: hidden;
}

/* 
   Smaller Cards - Used in Specific Cases:
     -  Selecting custom values
     -  Choosing a vote after revealing
     -  Displaying results
*/
.pokerCardSmallVersion {
  /* Small Dot */
  .pokerCardDot {
    --size: 10px;
    width: var(--size);
    height: var(--size);
    font-size: 0;
  }

  /* Positioning Small Dots */
  .pokerCardDotBottomRight:after,
  .pokerCardDotTopLeft:after {
    content: '⬤';
    font-size: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--theme-accent-icon);
  }

  /* Outer Card Adjustments */
  .pokerCardOuter {
    padding: var(--spacer-1);
  }

  /* Smaller Cards List */
  .pokerCardList {
    gap: var(--spacer-3);
    padding: var(--spacer-4) 0;
  }

  /* Small Card Content */
  .pokerCardContent {
    font-size: 12px;
    font-weight: 500;
    padding: calc(var(--corner-size) / 1.5) calc(var(--corner-size) / 3.4);
    min-width: 14px;
    text-align: center;
  }
}

/** New poker card end **/

.pokerCardListContainer {
  padding-top: var(--spacer-5);
  padding-bottom: var(--spacer-5);
  border: 1px solid var(--theme-button-border);
  border-radius: 4px;
}

.pokerPreviousResultsContainer {
  padding: var(--spacer-4) var(--spacer-2) var(--spacer-4) var(--spacer-2);
  border: 1px solid var(--theme-button-border);
  border-radius: 4px;
}

.pokerSeparatorLine {
  border-bottom: 1px solid var(--theme-light-border);
  margin-bottom: var(--spacer-4);
  border: none;
  padding: var(--spacer-6) 0 var(--spacer-2);
  margin-top: var(--spacer-2);
}

.pokerResultItem {
  display: flex;
}

.pokerResultItem {
  display: flex;
  flex-direction: column;
}

.pokerResultItemTopRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--spacer-2);
}

.pokerResultItemUserList {
  display: flex;
  gap: var(--spacer-2);
}
.pokerResultItemSelectButton {
  margin-left: auto;
  align-self: start;
}

.pokerResultItemVoteCount {
  margin-left: 1em;
}

#usernames {
  margin-top: 8px;
}

.pokerDetailsPanel {
  margin-top: var(--spacer-4);
  margin-bottom: var(--spacer-2);
}

.pokerDetailsPanel .text-center {
  display: flex;
  flex-direction: column;
  gap: var(--spacer-6);
}

.pokerDetailsPanel .text-center > .mb-4 {
  color: var(--theme-tertiary-text);
}
.pokerDetailsPanel .text-center * {
  margin: 0;
}

.pokerDetailsAlert {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 1;
}

.pokerScoreSummaries > * {
  padding: var(--spacer-2);
  border-left: 1px solid var(--theme-light-border);
  border-right: 1px solid var(--theme-light-border);
  border-bottom: 1px solid var(--theme-light-border);
}

.pokerScoreSummaries > :first-child {
  border-top: 1px solid var(--theme-light-border);
  border-radius: 4px 4px 0 0;
}

.pokerScoreSummariesUnselectedCards {
  display: flex;
  flex-direction: column;
  padding: 0;
  border-radius: 0 0 4px 4px;
}

.pokerScoreSummariesUnselectedCards > :first-child {
  color: var(--theme-tertiary-text);
  padding: var(--spacer-2) var(--spacer-2) 0 var(--spacer-2);
}

.pokerCustomValuesField {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(1, 1fr);
}

.pokerCustomValuesError {
  grid-template-rows: repeat(2, 1fr);
}
.pokerCustomValuesError > :last-child {
  grid-column: 1 / 3; /* span from grid column line 1 to 3 (i.e., span 2 columns) */
  grid-row: 2 / 3; /* same concept, but for rows */
  justify-self: center;
  align-self: end;
}

.pokerCustomValuesInput {
  width: auto;
  margin-bottom: 0 !important;
}

.pokerDetails {
  flex-grow: 1;
  padding-top: var(--spacer-5);
  padding-bottom: var(--spacer-3);
}

.pokerPreviousResult {
  display: flex;
  align-items: center;
  gap: var(--spacer-2);
  padding-left: var(--spacer-2);
  & + & {
    margin-top: var(--spacer-2);
    padding-top: var(--spacer-2);
    border-top: 1px solid var(--theme-light-border);
  }
}

.pokerPreviousResult:first-of-type {
  margin-top: var(--spacer-2);
}

.flexAlignCenter {
  display: flex;
  align-items: center;
}